export enum DashboardWidgets {
    LISTINGS_STATUS_SUMMARY,
    LISTINGS_WITHOUT_UPDATES,
}
